import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ArrowRight, ChevronDown } from 'lucide-react';
import { fadeInUp, staggerContainer } from '../lib/animations';
export function Hero() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '50%']);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  return <section ref={ref} id="home" className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden bg-gray-900" data-id="element-107">
      {/* Parallax Background */}
      <motion.div style={{
      y,
      opacity
    }} className="absolute inset-0 z-0" data-id="element-108">
        <img src="https://images.unsplash.com/photo-1596356453261-0d265ae2520a?q=80&w=2070&auto=format&fit=crop" alt="Luxury Silk Fabric Texture" className="w-full h-full object-cover opacity-60" data-id="element-109" />
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/40 via-gray-900/20 to-gray-900/80" data-id="element-110"></div>
      </motion.div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-20" data-id="element-111">
        <motion.div variants={staggerContainer} initial="hidden" animate="visible" className="max-w-4xl mx-auto text-center" data-id="element-112">
          <motion.div variants={fadeInUp} className="mb-6 flex justify-center" data-id="element-113">
            <span className="px-4 py-1.5 rounded-full border border-white/20 bg-white/10 backdrop-blur-md text-white/90 text-sm font-medium tracking-wider uppercase" data-id="element-114">
              Established 1998 • Mumbai, India
            </span>
          </motion.div>

          <motion.h1 variants={fadeInUp} className="text-5xl md:text-7xl lg:text-8xl font-bold text-white tracking-tight leading-[1.1] mb-8" data-id="element-115">
            Weaving The Future <br data-id="element-116" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-200 to-white" data-id="element-117">
              Of Global Textiles
            </span>
          </motion.h1>

          <motion.p variants={fadeInUp} className="text-lg md:text-xl text-gray-200 mb-10 max-w-2xl mx-auto leading-relaxed font-light" data-id="element-118">
            Shivaay Fashion delivers premium manufacturing excellence. From
            intricate silks to durable cottons, we export quality craftsmanship
            to the world.
          </motion.p>

          <motion.div variants={fadeInUp} className="flex flex-col sm:flex-row gap-5 justify-center items-center" data-id="element-119">
            <motion.a href="#products" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="group relative px-8 py-4 bg-white text-[#1e3a8a] font-bold rounded-full overflow-hidden shadow-[0_0_20px_rgba(255,255,255,0.3)] transition-all" data-id="element-120">
              <span className="relative z-10 flex items-center" data-id="element-121">
                Explore Collection{' '}
                <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-122" />
              </span>
              <div className="absolute inset-0 bg-blue-50 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300" data-id="element-123"></div>
            </motion.a>

            <motion.a href="#contact" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="px-8 py-4 bg-transparent border border-white/30 text-white font-semibold rounded-full hover:bg-white/10 backdrop-blur-sm transition-colors" data-id="element-124">
              Contact Us
            </motion.a>
          </motion.div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 text-white/50 flex flex-col items-center gap-2" data-id="element-125">
        <span className="text-xs uppercase tracking-widest" data-id="element-126">Scroll</span>
        <motion.div animate={{
        y: [0, 8, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-127">
          <ChevronDown className="w-6 h-6" data-id="element-128" />
        </motion.div>
      </motion.div>
    </section>;
}